export default __webpack_public_path__ + "static/media/Jarm_Logo.eade6ac8.svg";